/* eslint-disable  */
import axios, { AxiosInstance } from 'axios';
import {
  injectDefaultHeaders,
  injectAuthorization,
  injectNetworkErrorHandler,
} from './injectors';

const NetworkClient: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

NetworkClient.interceptors.request.use(injectDefaultHeaders);
NetworkClient.interceptors.request.use(injectAuthorization);
NetworkClient.interceptors.response.use(
  (response) => response,
  injectNetworkErrorHandler,
);

export default NetworkClient;
